import { DataTableColumnHeader } from "@/shared/components/table";
import type { ColumnDef } from "@tanstack/react-table";
import { useMemo } from "react";
import type { CollectionsSizeRow } from "../types/collection-types";

export function useCollectionsSizeColumns() {
  return useMemo<ColumnDef<CollectionsSizeRow>[]>(
    () => [
      {
        accessorKey: "channel",
        header: ({ column }) => <DataTableColumnHeader column={column} title="Channel" />,
      },
      {
        accessorKey: "report_type",
        header: ({ column }) => <DataTableColumnHeader column={column} title="Report Type" />,
      },
      {
        accessorKey: "dw_account_id",
        header: ({ column }) => <DataTableColumnHeader column={column} title="DW Account ID" />,
      },
      {
        accessorKey: "target_date",
        header: ({ column }) => <DataTableColumnHeader column={column} title="Target Date" />,
      },
      {
        accessorKey: "row_count",
        header: ({ column }) => <DataTableColumnHeader column={column} title="Row Count" />,
        cell: ({ row }) => row.original.row_count.toLocaleString(),
      },
      {
        accessorKey: "file_size_mb",
        header: ({ column }) => <DataTableColumnHeader column={column} title="File Size (MB)" />,
        cell: ({ row }) =>
          row.original.file_size_mb.toLocaleString(undefined, { maximumFractionDigits: 2 }),
      },
      {
        accessorKey: "requested_time",
        header: ({ column }) => <DataTableColumnHeader column={column} title="요청 시간" />,
        cell: ({ row }) => row.original.requested_time || "-",
      },
    ],
    []
  );
}
